module.exports = __webpack_public_path__ + "img/ic_add_white.cf09406e.svg";